module.exports = __webpack_public_path__ + "img/model_m66_small.77966f2f.png";